import { FeedStoreContext } from './FeedStoreContext';

export const useFeedStore = FeedStoreContext.useStore;
